import { createAction } from '@housinganywhere/safe-redux';

import { Actions } from '../constants';
import { RealtimeMessage } from '../types';

interface MessagePayload {
  type: string;
  message: RealtimeMessage;
}

interface MessageEvent {
  attributes: {
    type: string;
  };
  body: RealtimeMessage;
}

export const receiveMessage = (p: MessagePayload) =>
  createAction(Actions.RECEIVE_MESSAGE, p);

export default (message: MessageEvent) =>
  receiveMessage({
    message: message.body,
    type: message.attributes.type,
  });
